import {TicketBuyAndUseResultVo} from '../../common/shared/api/nicolas/vo/TicketBuyAndUseResultVo.interface';
import {TicketBuyAndUseMutationPayload} from '../generated/types';

export function createTicketBuyAndUseMutationPayload({
  remain_cash,
  buy_ticketinfo,
  ticket_uid,
}: TicketBuyAndUseResultVo): TicketBuyAndUseMutationPayload {
  return {
    remainCash: remain_cash,
    buyTicketinfo: buy_ticketinfo,
    ticketUid: BigInt(ticket_uid).toString(),
  };
}
